import { ModalValuesDto } from '@asset-metrix/portal-gateway-client-js';
import { MutationFunction } from '@tanstack/react-query';

import { extractErrorMessage } from '../../utils/errorMessage';
import { HttpError } from '../../utils/errors';
import { portalGatewayClient } from '../portalGatewayClient';

type ReqBody = NonNullable<
  Parameters<
    typeof portalGatewayClient.table.searchTableRowModalValues
  >[1]['data']
>;

export const searchTableRowModalValues: MutationFunction<
  ModalValuesDto['modalValues'],
  {
    contentId: string;
    data?: Record<string, unknown>;
    context?: ReqBody['context'];
  }
> = async ({ contentId, data, context }) => {
  const response = await portalGatewayClient.table.searchTableRowModalValues(
    contentId,
    {
      data: {
        context,
        // @todo: Use correct types
        data: data as ReqBody['data'],
      },
    }
  );

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(response.error, 'Error searching modal values.'),
      response.status
    );
  }
  return response.data.data.modalValues;
};
